import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Subscribe from "./src/Subscribe";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "dataset-vs-ground-truth-dataset"
    }}>{`Dataset vs Ground-Truth Dataset`}</h1>
    <p>{`Datasets are a collection of samples of data. The data can be images, audio,
text, matrices of numbers or even rows of an Excel spreadsheet. When doing machine learning, you'll
usually need a ground-truth dataset. A ground-truth dataset is a regular dataset,
but with annotations added to it. Annotations can be boxes drawn over images,
written text indicating samples, a new column of a spreadsheet or anything else
the machine learning algorithm should learn to output.`}</p>
    <p><img alt="dataset" src={require("./assets/misc/dataset.png")} /></p>
    <p>{`A couple quick examples:`}</p>
    <ul>
      <li parentName="ul">{`If you're predicting risk of someone defaulting on a loan, your
dataset may be a spreadsheet containing information about people. Your ground-truth
dataset would include a column that indicates if the person defaulted or not`}</li>
      <li parentName="ul">{`If you're trying to identify animals in a picture, your dataset might be images
of pets. Your ground-truth dataset would be images of pets with bounding boxes
showing where the animals are in the image, as well as labels that indicate what
animal is in the box.`}</li>
    </ul>
    <p><img alt="ground-truth dataset" src={require("./assets/misc/ground-truth-dataset.png")} /></p>
    <h2 {...{
      "id": "how-do-i-get-a-dataset"
    }}>{`How do I get a dataset?`}</h2>
    <p>{`Many datasets companies use come from customer data, such as engagement or spending
information that could help predict when a promotion should be sent to a user. There are
also a host of online datasets available:`}</p>
    <ul>
      <li parentName="ul">{`The python library `}<a parentName="li" {...{
          "href": "https://scikit-learn.org/stable/datasets/index.html"
        }}>{`scikit-learn`}</a>{`
has some easy python methods for importing toy datasets that can be used for gaining
familiarity with machine learning`}</li>
      <li parentName="ul">{`The U.S. Government releases a lot of data about Public Safety, Research, Education and more at `}<a parentName="li" {...{
          "href": "https://www.data.gov/"
        }}>{`data.gov`}</a>{`.`}</li>
      <li parentName="ul">{`Google recently introduced a `}<a parentName="li" {...{
          "href": "https://datasetsearch.research.google.com/"
        }}>{`dataset search`}</a>{` that helps you find freely available datasets`}</li>
    </ul>
    <h2 {...{
      "id": "how-do-i-get-a-ground-truth-dataset"
    }}>{`How do I get a ground-truth dataset?`}</h2>
    <p>{`There are many freely available tools for annotating a dataset to make it a
ground-truth dataset such as `}<a parentName="p" {...{
        "href": "https://universaldatatool.com"
      }}>{`Universal Data Tool`}</a>{`,
`}<a parentName="p" {...{
        "href": "https://labelstud.io"
      }}>{`Label Studio`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/tzutalin/labelImg"
      }}>{`Labelimg`}</a>{`.`}</p>
    <p>{`You can see screenshots and interactive search of different machine learning tools using `}<a parentName="p" {...{
        "href": "https://waoai.github.io/compare-data-tools/"
      }}>{`Compare Data Tools`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://wao.ai"
      }}>{`Companies`}</a>{` will also `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=lr22P8x_A_g"
      }}>{`annotate your data for you`}</a>{`. The biggest challenge for annotating
data externally is tracking the quality of your labels. We recommend taking a sample
slice of your data from the annotation company and measure the percentage of samples
that are correctly annotated.`}</p>
    <h2 {...{
      "id": "training-dataset-vs-ground-truth-dataset"
    }}>{`Training Dataset vs Ground-truth Dataset`}</h2>
    <p>{`"Training dataset" and "ground-truth dataset" are sometimes used interchangeably,
but they are actually slightly different. When building a machine learning dataset, you
break your ground-truth dataset into two smaller datasets: the training dataset and the
testing dataset. You then train your machine learning algorithm on the training dataset,
and test it's ability to work on the testing dataset.`}</p>

    <Subscribe mdxType="Subscribe" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      